import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import Header from '../../../shared/Header/Header';
import homeVideo from '../../../../assets/home/HomeGif.mp4';
import SelectInfoSection from './SelectInfoSection/SelectInfoSection';
import NavigateButton from '../../../../components/NavigateButton/NavigateButton';
import { heroSectionStyles } from './HeroSection.styles';

const HeroSection = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box sx={heroSectionStyles.container}>
      {/* Video Background */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        disablePictureInPicture
        disableRemotePlayback
        controlsList="nodownload nofullscreen noremoteplayback"
        sx={heroSectionStyles.video}
      >
        <source src={homeVideo} type="video/mp4" />
      </Box>

      {/* Background Mask */}
      <Box sx={heroSectionStyles.bgMask} />

      {/* Header */}
      <Box sx={heroSectionStyles.headerContainer}>
        <Header isSecondary={true} />
      </Box>

      {/* Centered Text Section */}
      <Box sx={heroSectionStyles.centeredTextSection}>
        <Typography sx={heroSectionStyles.typography} mb={{xs: '10px', lg: '0px'}}>
          Exceptional Stays
        </Typography>
        <Typography sx={heroSectionStyles.typography}>
          Elevated Living
        </Typography>
        {isMdOrBelow ? (
          <Box mt={"50px"}>
            <NavigateButton
              title="Start Your Search"
              isSecondary={true}
              onClick={() => window.open('https://royal-vista.guestybookings.com/en/properties', '_blank')}
            />
          </Box>
        ) : (
          <SelectInfoSection />
        )}
      </Box>
    </Box>
  );
};

export default HeroSection;

